import { useEffect } from 'react';

const BASE_TITLE = 'SomosTorre';

const PAGE_META = {
  '/': {
    title: 'SomosTorre — Tu ciudad, sin saltos | Torrelavega',
    description: 'Plataforma cívica gratuita para Torrelavega: llegadas de autobuses y trenes casi en tiempo real, eventos, comercio local y servicios municipales.',
  },
  '/torrebus': {
    // Estimates and stops, not timetables: Torrebus publishes no per-stop timetable data we show.
    title: 'Torrebus — Llegadas estimadas y paradas | SomosTorre',
    description: 'Llegadas estimadas de Torrebus en cada parada del autobús urbano de Torrelavega, mapa de paradas y horarios del autobús a Santander.',
  },
  '/renfe': {
    // The page lists the lines through Torrelavega only (Renfe.js TORRELAVEGA_LINES: C1 and C2).
    title: 'Renfe Cercanías — Trenes en vivo | SomosTorre',
    description: 'Trenes de Cercanías Renfe que pasan por Torrelavega (líneas C1 y C2): salidas, retrasos y trenes en vivo.',
  },
  '/torrebici': {
    // Torrebici publishes no bike availability (Torrebici.js says so): stations only.
    title: 'Torrebici — Estaciones de bicicleta pública | SomosTorre',
    description: 'Estaciones del servicio público de bicicletas Torrebici en Torrelavega, en el mapa y por barrio.',
  },
  '/comercio': {
    title: 'Comercio Local — Negocios de Torrelavega | SomosTorre',
    description: 'Comercios de Torrelavega: restaurantes, bares, tiendas y servicios con mapa, valoraciones y horarios, de Google Places y la Cámara de Comercio.',
  },
  '/mapa': {
    title: 'Mapa Vivo — Mapa interactivo | SomosTorre',
    description: 'Mapa interactivo de Torrelavega: Torrebus, trenes, aparcamiento, Torrebici, tráfico, obras, gasolineras, servicios y comercios.',
  },
  '/agenda': {
    title: 'Agenda Cultural — Eventos en Torrelavega | SomosTorre',
    description: 'Eventos culturales, teatro, conciertos y actividades programadas en Torrelavega. Agenda actualizada diariamente.',
  },
  '/boletines': {
    title: 'Boletines Oficiales — Ayuntamiento y BOC | SomosTorre',
    description: 'Anuncios del Ayuntamiento de Torrelavega, el Boletín Oficial de Cantabria (BOC) y la Cámara de Comercio, resumidos en lenguaje claro y con enlace al original.',
  },
  '/incidencias': {
    title: 'Incidencias — Problemas urbanos | SomosTorre',
    description: 'Comparte incidencias urbanas (baches, alumbrado, limpieza) y prepara un email para el Ayuntamiento de Torrelavega.',
  },
  '/aparcamiento': {
    // Not «en vivo» / «en tiempo real»: Parkunload's count stops at night, on Sundays and when it
    // fails, and the page then says «última lectura». A title cannot say which.
    title: 'Aparcamiento — Plazas libres de la ERA | SomosTorre',
    description: 'Plazas libres de la ERA según Parkunload, horarios de la ordenanza en vigor y aparcamientos en altura de Torrelavega.',
  },
  '/sobre': {
    title: 'Sobre SomosTorre — Nuestra historia | Eolas Prints',
    description: 'SomosTorre es una iniciativa cívica gratuita de Tanuj Goswami y Eolas Prints, S.L. para los vecinos de Torrelavega.',
  },
  '/preguntas-frecuentes': {
    title: 'Preguntas frecuentes | SomosTorre',
    description: 'Respuestas sobre SomosTorre: tu cuenta, cómo reportar incidencias, la ayuda entre vecinos, autobuses, ZBE, farmacias de guardia, trámites y la app.',
  },
  '/legal': {
    title: 'Información Legal — Privacidad y Cookies | SomosTorre',
    description: 'Política de privacidad, aviso legal y política de cookies de SomosTorre. RGPD y LOPDGDD.',
  },
  '/admin': {
    title: 'Panel de Control | SomosTorre',
    description: 'Panel de administración de SomosTorre.',
  },
  '/perfil': {
    title: 'Mi Perfil | SomosTorre',
    description: 'Gestiona tu cuenta de vecino, exporta tus datos o elimina tu cuenta.',
  },
  '/tramites': {
    title: 'Trámites Municipales — Guía paso a paso | SomosTorre',
    description: 'Trámites habituales del Ayuntamiento de Torrelavega paso a paso: empadronamiento, certificados, licencias, tributos y ayudas, con documentos y cita previa.',
  },
  '/residuos': {
    title: 'Reciclaje y Residuos — Guía inteligente | SomosTorre',
    description: 'Guía de reciclaje para Torrelavega: qué va en cada contenedor, la recogida de muebles y electrodomésticos y los puntos limpios, con asistente IA.',
  },
  '/transparencia': {
    // The page shows the incidencias neighbours publish in SomosTorre, not the Ayuntamiento's data.
    title: 'Transparencia — Incidencias de Torrelavega en cifras | SomosTorre',
    description: 'Cómo van las incidencias que publican los vecinos de Torrelavega en SomosTorre: pendientes y resueltas, por prioridad, categoría y barrio.',
  },
  '/contratacion': {
    title: 'Contratación Pública — Contratos de Torrelavega | SomosTorre',
    description: 'Contratos públicos del Ayuntamiento de Torrelavega desde 2022: busca por empresa, importe, tipo y estado. Datos oficiales de la PLACSP.',
  },
  '/contratacion/:id': {
    title: 'Contrato — Contratación Pública de Torrelavega | SomosTorre',
    description: 'Información completa del contrato público: importe, adjudicatario, procedimiento, licitadores. Datos oficiales de la PLACSP.',
  },
  '/deportes': {
    title: 'Deportes — Partidos y equipos de Torrelavega | SomosTorre',
    description: 'Próximos partidos y últimos resultados de la Gimnástica, el Bathco BM Torrelavega y el Grupo Alega Cantabria.',
  },
  '/novedades': {
    title: 'Novedades — Qué hay de nuevo | SomosTorre',
    description: 'Lo último en SomosTorre: nuevas funciones y cómo sacarles partido.',
  },
  '/contratacion/empresa': {
    title: 'Perfil de Empresa — Contratación Pública de Torrelavega | SomosTorre',
    description: 'Contratos públicos adjudicados a esta empresa por el Ayuntamiento de Torrelavega. Datos oficiales de la PLACSP.',
  },
  '/contratacion/empresa/:name': {
    title: 'Perfil de Empresa — Contratación Pública de Torrelavega | SomosTorre',
    description: 'Contratos públicos adjudicados a esta empresa por el Ayuntamiento de Torrelavega. Datos oficiales de la PLACSP.',
  },
  '/descargas': {
    title: 'Descarga SomosTorre — La App de Torrelavega para iPhone y Android',
    description: 'Descarga gratis SomosTorre. Tiempo, transporte, playas, contratos públicos, incidencias y comunidad de Torrelavega en tu móvil.',
  },
  '/radiografia': {
    // Official statistics, each with its period, updated weekly or monthly: not live data.
    // (/en-cifras only redirects here, EnCifras.js, so it has no entry of its own.)
    title: 'Radiografía de Torrelavega — Cifras oficiales | SomosTorre',
    description: 'Cifras oficiales de Torrelavega: población, paro, contratos, renta, hacienda municipal y criminalidad (INE, ICANE, SEPE, Interior), con su periodo y su fuente.',
  },
  '/servicios': {
    title: 'Teléfonos municipales de Torrelavega | SomosTorre',
    description: 'Teléfonos de emergencias, Ayuntamiento, centros de salud, agua, residuos, servicios sociales y juzgados de Torrelavega, comprobados en las webs oficiales.',
  },
  '/vecinos': {
    // Mutual help (requests, offers, private messages), not a forum.
    title: 'Ayuda entre vecinos — Pide u ofrece ayuda | SomosTorre',
    description: 'Pide u ofrece ayuda a otros vecinos de Torrelavega: recados, mudanzas, compañía… con mensajes privados y karma.',
  },
  '/trafico': {
    title: 'Tráfico en vivo — Estado de carreteras | SomosTorre',
    description: 'Estado del tráfico en las carreteras de Torrelavega (A-67, A-8, S-30, N-611 y N-623): incidencias, corredores y cámaras de la DGT.',
  },
  '/playas': {
    title: 'Playas cerca de Torrelavega — Previsión y estado | SomosTorre',
    description: 'Previsión meteorológica de las mejores playas cerca de Torrelavega: Suances, San Vicente, Oyambre. Temperatura, oleaje, viento y UV.',
  },
  '/montanas': {
    // The page has no routes, and AEMET's forecast is for the municipality in the valley, not the summit.
    title: 'Montañas cerca de Torrelavega — Previsión AEMET | SomosTorre',
    description: 'Previsión de AEMET para los pueblos al pie del Dobra, Saja-Besaya, Monte Castillo, Peña Cabarga y Picos de Europa: temperatura, viento y lluvia en el valle.',
  },
  '/que-ver': {
    title: 'Qué ver en Torrelavega — Lugares de interés | SomosTorre',
    description: 'Descubre los lugares más emblemáticos de Torrelavega: Banco Gigante, Parque Barquín, Mercado de Ganados, esculturas urbanas.',
  },
  '/patrimonio': {
    title: 'Patrimonio y Cuevas — Altamira, Santillana | SomosTorre',
    description: 'Arte rupestre y patrimonio cerca de Torrelavega: Cueva de Altamira, Santillana del Mar, Comillas, Capricho de Gaudí.',
  },
  '/accesibilidad': {
    title: 'Accesibilidad — Declaración y ajustes | SomosTorre',
    description: 'Declaración de accesibilidad de SomosTorre y ajustes de modo oscuro, alto contraste, texto grande y animaciones.',
  },
  '/patrona': {
    title: 'La Patrona {FIESTA_YEAR} — Clasificación de peñas y eventos | SomosTorre',
    description: 'Fiestas de la Virgen Grande de Torrelavega: clasificación del concurso de peñas SOMOS39300 (en directo durante las fiestas), programa e inscripción.',
  },
  '/visitar': {
    title: 'Visitar Torrelavega — Playas, montañas, patrimonio | SomosTorre',
    description: 'Todo lo que puedes visitar en Torrelavega y alrededores: playas, montañas, cuevas y patrimonio.',
  },
  '/tiempo': {
    title: 'El Tiempo en Torrelavega — Previsión hora a hora | SomosTorre',
    // Only what the page shows: the coastal forecast is not on it, and the radar card appears
    // only when AEMET's image is recent (its refresh is off), so neither is promised here.
    description: 'Previsión hora a hora para Torrelavega: temperatura, lluvia, viento y avisos de AEMET, índice UV, calidad del aire, polen, ríos y embalses.',
  },
  '/gasolineras': {
    title: 'Gasolineras — Precios de combustible | SomosTorre',
    // No station count: it changes with MITECO's list (22 on 27 Sep 2026, never 30).
    description: 'Precios de gasolina y diésel en las gasolineras de Torrelavega y alrededores (MITECO). Mejor opción local, filtro por tipo y evolución de los últimos 30 días.',
  },
  '/buscar': {
    title: 'Buscar | SomosTorre',
    description: 'Busca en SomosTorre: farmacias, paradas, trámites, comercios, eventos, contratos y más de Torrelavega.',
  },
  '/puntos-carga': {
    title: 'Puntos de Carga EV — Estaciones de recarga | SomosTorre',
    description: 'Puntos de recarga para vehículos eléctricos cerca de Torrelavega. Estado operativo, potencia, conectores y localización en mapa.',
  },
  '/precio-luz': {
    title: 'Precio de la Luz Hoy — PVPC hora a hora | SomosTorre',
    description: 'Precio de la electricidad PVPC hora a hora en España: horas baratas y caras de hoy, precio mayorista, mix de generación y CO2. Datos de ESIOS (Red Eléctrica).',
  },
  '/zbe': {
    title: 'ZBE Torrelavega — Zona de Bajas Emisiones | SomosTorre',
    description: 'Zona de Bajas Emisiones de Torrelavega: consulta tu matrícula, horarios, mapa de la zona, etiquetas ambientales y opciones sin etiqueta.',
  },
  // Consulta de parcela: /parcela is indexed, each /parcela/<ref> report is not (robotsFor).
  '/parcela': {
    title: 'Consulta de parcela en Torrelavega — suelo, riesgos y patrimonio | SomosTorre',
    description: 'Busca una parcela de Torrelavega por dirección o referencia catastral: superficie, clase de suelo del PGOU, zonas inundables y patrimonio protegido. Informe orientativo.',
  },
  '/parcela/:ref': {
    title: 'Parcela — Consulta urbanística orientativa | SomosTorre',
    description: 'Superficie, clase de suelo, zonas inundables y patrimonio de una parcela de Torrelavega, con datos públicos del Catastro y del Gobierno de Cantabria.',
  },
  '/urbanismo': {
    title: 'Planeamiento de Torrelavega — PGOU, modificaciones y nuevo plan | SomosTorre',
    description: 'El Plan General de Torrelavega en vigor y sus modificaciones puntuales con sus documentos, los planes de desarrollo, en qué punto está el nuevo PGOU y las novedades urbanísticas.',
  },
  '/festivos': {
    title: 'Festivos Torrelavega {YEAR} — Calendario completo | SomosTorre',
    description: 'Calendario de festivos {YEAR} en Torrelavega: días nacionales, Cantabria y locales (San Roque, San Cipriano). Próximo festivo y cuenta atrás.',
  },
  '/supermercados': {
    title: 'Supermercados en Torrelavega — Horarios y ubicaciones | SomosTorre',
    description: 'Todos los supermercados de Torrelavega: Mercadona, Lidl, Carrefour, ALDI, DIA, BM, Lupa y más. Horarios, estado abierto/cerrado, mapa y cómo llegar.',
  },
  '/farmacias': {
    // The pharmacy list has no opening hours (Farmacias.js), so no «abiertas ahora» or «horarios».
    title: 'Farmacias en Torrelavega — De guardia hoy | SomosTorre',
    description: 'Farmacia de guardia de hoy en Torrelavega (Colegio de Farmacéuticos de Cantabria) y todas las farmacias con dirección, teléfono, mapa y cómo llegar.',
  },
};

// The titles carry {YEAR}/{FIESTA_YEAR} instead of a frozen year: '/patrona' read
// "La Patrona 2026" in the tab, the SEO title and the app's native top bar while the page
// heading already said 2027. {FIESTA_YEAR} mirrors festivalYear() in pages/Patrona.js — the
// fiestas end on 25 August, after which the next edition is the relevant one.
export function resolveYears(text) {
  const now = new Date();
  const afterFiesta = now.getMonth() > 7 || (now.getMonth() === 7 && now.getDate() > 25);
  return text
    .replace('{FIESTA_YEAR}', afterFiesta ? now.getFullYear() + 1 : now.getFullYear())
    .replace('{YEAR}', now.getFullYear());
}

// Which entry describes a path: an exact key first, then a pattern key ('/contratacion/:id'),
// then the nearest section ('/vecinos' for '/vecinos/<id>'), and only then Inicio's.
// The lookup used to be exact only, so the two pattern entries above never matched, and every
// detail page (a contract, a company, an ayuda) and /novedades carried Inicio's title. In the
// app that title is what the native top bar shows, so those pages were headed by the brand, not
// their name (seen on the iPhone simulator). Pages that set a more specific title of their own
// once their data loads (EventDetail, TramiteDetail) still do.
function metaFor(pathname) {
  if (PAGE_META[pathname]) return PAGE_META[pathname];
  const parts = pathname.split('/');
  const pattern = Object.keys(PAGE_META).find((key) => {
    const k = key.split('/');
    return key.includes(':') && k.length === parts.length && k.every((seg, i) => seg.startsWith(':') || seg === parts[i]);
  });
  if (pattern) return PAGE_META[pattern];
  for (let n = parts.length - 1; n > 1; n--) {
    const section = parts.slice(0, n).join('/');
    if (PAGE_META[section]) return PAGE_META[section];
  }
  return PAGE_META['/'];
}

/** The fixed pages with their title and description as written ({YEAR} unresolved). public/seo.js
 *  sets the same before React loads; it is generated from this, and a test keeps the two equal:
 *  UPDATE_SEO=1 CI=true craco test usePageMeta rewrites it. */
export function staticPageMeta() {
  return Object.keys(PAGE_META).filter((k) => !k.includes(':')).map((path) => ({
    path, title: PAGE_META[path].title, description: PAGE_META[path].description,
  }));
}

/** The robots meta for a path. Private pages: never in search results, links not followed.
 *  robots.txt already keeps crawlers out of /perfil and /admin, but a blocked URL can still be
 *  listed if something links to it, and /verificar (the email-link landing, with a token in its
 *  URL) was not blocked at all. Search results (/buscar) are a view of other pages, not a page.
 *  A neighbour's help request (/vecinos/<id>) and an incident (/incidencias/<id>) show residents'
 *  names, so they stay out of the index too; their links are still followed, and the lists
 *  (/vecinos, /incidencias) remain indexable. public/seo.js sets the same value before React
 *  loads, for crawlers that do not run the app: keep the two in step. */
export function robotsFor(rawPathname) {
  const pathname = normalizePath(rawPathname);
  if (/^\/(perfil|admin|verificar)(\/|$)/.test(pathname)) return 'noindex, nofollow';
  if (pathname === '/buscar') return 'noindex, follow';
  // Consulta de parcela: the search page (/parcela) is indexed; the report of each cadastral
  // reference (/parcela/<ref>, 10,085 of them, one per address) is not: what it says about a
  // household's home should not come up when someone searches an address, the Catastro's per-unit
  // data must not read as a republished register, and an unofficial report should not rank as if it
  // were the council's (Tanuj, 1 Oct 2026; before, all of /parcela was noindex).
  if (/^\/parcela\/./.test(pathname)) return 'noindex, follow';
  if (/^\/(vecinos|incidencias)\/[^/]+/.test(pathname)) return 'noindex, follow';
  return 'index, follow';
}

/** «/farmacias/» → «/farmacias»: the same page. With the slash it got Inicio's title and a
 *  canonical of its own (a duplicate), as production's prerender showed. */
export function normalizePath(pathname) {
  const p = String(pathname || '/');
  return p.length > 1 ? p.replace(/\/+$/, '') || '/' : p;
}

export function usePageMeta(rawPathname) {
  const pathname = normalizePath(rawPathname);
  useEffect(() => {
    const raw = metaFor(pathname);
    const meta = { title: resolveYears(raw.title), description: resolveYears(raw.description) };
    document.title = meta.title;

    // Report the title to the native app's top bar. Layout also does this from a <title>
    // MutationObserver, but /admin renders OUTSIDE Layout (App.js: it is its own top-level
    // route, not under the Layout-wrapped "*" catch-all), so nothing reported there and the
    // bar kept the previous page's title. This hook runs for every route via PageMetaUpdater,
    // which sits outside <Routes>, so it covers /admin too — and it fires exactly when the
    // title is set, with no observer race. Duplicate posts are harmless: the native side just
    // assigns the title it is given.
    try {
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'PAGE_TITLE',
          title: meta.title.split(/ — | \| /)[0].trim(),
          path: pathname,
        }));
      }
    } catch { /* bridge unavailable — web build */ }

    const descTag = document.querySelector('meta[name="description"]');
    if (descTag) descTag.setAttribute('content', meta.description);

    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', meta.title);

    const ogDesc = document.querySelector('meta[property="og:description"]');
    if (ogDesc) ogDesc.setAttribute('content', meta.description);

    const twTitle = document.querySelector('meta[name="twitter:title"]');
    if (twTitle) twTitle.setAttribute('content', meta.title);

    const twDesc = document.querySelector('meta[name="twitter:description"]');
    if (twDesc) twDesc.setAttribute('content', meta.description);

    // Update canonical URL per page
    const canonicalUrl = `https://somostorre.com${pathname === '/' ? '' : pathname}`;
    let canonicalTag = document.querySelector('link[rel="canonical"]');
    if (canonicalTag) {
      canonicalTag.setAttribute('href', canonicalUrl);
    }

    // See robotsFor. Every other route resets to the index.html default, since this tag outlives
    // the page that set it.
    const robotsTag = document.querySelector('meta[name="robots"]');
    if (robotsTag) robotsTag.setAttribute('content', robotsFor(pathname));

    // Update og:url per page
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) ogUrl.setAttribute('content', canonicalUrl);

    return () => {
      document.title = `${BASE_TITLE} — Tu ciudad, sin saltos`;
    };
  }, [pathname]);
}
